export type ServiceHistoryModalProps = {
  regNo?: string;
  vin?: string;
  onClose: () => void;
};

export type SectionTab =
  | 'CDK Vehicle History'
  | 'Vauxhall Vehicle History'
  | 'Proof of Service History'
  | 'Vauxhall Vehicle History PDF';

export const TABS: { tab: SectionTab; order: number }[] = [
  { tab: 'CDK Vehicle History', order: 0 },
  { tab: 'Vauxhall Vehicle History', order: 1 },
  { tab: 'Proof of Service History', order: 2 },
  { tab: 'Vauxhall Vehicle History PDF', order: 3 }
];
